import React from 'react';
import { useSelector } from 'react-redux';

import { i18n } from 'i18n/index.js';
import sessionSelectors from 'features/shared/services/session/selectors.js';
import Paragraph from '../../shared/components/paragraph';
import Heading2 from '../../shared/components/heading2';
import Section from '../../shared/components/section.js';

const AboutCustomerSection = () => {
  const translationsConfig = useSelector(
    sessionSelectors.getTranslationsConfig
  );

  return (
    <Section>
      <Heading2>
        {i18n('report.aboutInvestment.header', translationsConfig)}
      </Heading2>
      {i18n('report.aboutInvestment.text', translationsConfig)}
    </Section>
  );
};

export default AboutCustomerSection;
